import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from '../../forecast-app/shared/components/buttons/button/button';
import {BUTTON_STYLE, BUTTON_COLOR} from '../../constants';
import Receipt from '../trial-end/receipt';
import {injectIntl} from 'react-intl';
import * as tracking from '../../tracking';

class OrderComplete extends Component {
	componentDidMount() {
		tracking.trackPage('order-complete');
	}

	render() {
		const {formatMessage} = this.props.intl;
		return (
			<div className={'order-complete-container'}>
				<div className={'order-complete-top-block'} />
				<div className={'order-complete'} data-cy={'order-complete'}>
					<div className={'receipt-shadow'} />
					<div className={'animation-wrapper animated fadeInDown'}>
						<div className={'receipt-top-section'}>
							<div className={'receipt-thank-you'}>{formatMessage({id: 'thank_you.header_top'})}</div>
							<div className={'receipt-description'}>{formatMessage({id: 'receipt.finisher_message'})}</div>
						</div>
						<div className={'receipt-divider'}>
							<div className={'orb right'} />
							<div className={'shadow-hider-right'} />
							<div className={'dotted-line'} />
							<div className={'orb left'} />
							<div className={'shadow-hider-left'} />
						</div>
						<div className={'today-line'}>
							<div className={'today-text'}>{this.props.date}</div>
						</div>
						<Receipt {...this.props.receiptProps} currency={this.props.currency} />
					</div>
				</div>
				<Button onClick={this.props.onComplete} text={'TAKE ME TO THE APP'} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.GREEN} />
			</div>
		);
	}
}
OrderComplete.propTypes = {
	onComplete: PropTypes.func.isRequired,
};
export default injectIntl(OrderComplete);
